import {
  getStatus,
  getIconType,
  getImportance,
  getSolvability,
} from '../../constants/seoMappings';

/**
 * Generates message for mixed content section
 * @param {Object} data - The mixed content data object
 * @returns {string|null} - Message for empty state or null if table should be displayed
 */
const generateMessage = (data) => {
  const httpResources = data?.httpResources || [];

  if (httpResources.length === 0) {
    return 'No mixed content was found.';
  }

  // Return null when mixed content found - table will be displayed
  return null;
};

/**
 * Transforms the mixed_content criteria from WooRank API response
 * @param {Object} mixedContentCriteria - The mixed_content criteria object from the API
 * @returns {Object} - Transformed mixed content data for React components
 */
export const transformMixedContent = (mixedContentCriteria) => {
  // Handle missing criteria - use 'neutral' status (maps to 'info' icon)
  if (!mixedContentCriteria) {
    return {
      status: getStatus('neutral'),
      iconType: getIconType('neutral'),
      importance: { level: 0, text: '' },
      solvability: { level: 0, text: '' },
      isEmpty: true,
      message: 'No mixed content was found.',
      data: null,
    };
  }

  const data = mixedContentCriteria?.data || {};
  const wooRankStatus = mixedContentCriteria?.status || 'neutral';
  const importance = mixedContentCriteria?.importance || 0;
  const solvability = mixedContentCriteria?.solvability || 0;

  const httpResources = data?.httpResources || [];
  const isEmpty = httpResources.length === 0;

  return {
    status: getStatus(wooRankStatus),
    iconType: getIconType(wooRankStatus),
    importance: getImportance(importance),
    solvability: getSolvability(solvability),
    isEmpty,
    message: generateMessage(data),
    data: isEmpty ? null : {
      httpResources: httpResources.map((url) => ({
        url: typeof url === 'string' ? url : (url?.url || ''),
      })),
    },
  };
};

export default transformMixedContent;

